import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cx } from '../../utils';
export const useAddonClasses = ({ className, position }) => {
    return cx('drop-shadow-sm h-12 appearance-none m-0 flex items-center justify-center px-3 bg-transparent border border-gray-500 min-w-16 cursor-pointer', 'text-sm font-normal text-gray-950', 'focus:outline-none focus-visible:z-10 focus-visible:border-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2', position === 'left'
        ? 'rounded-none ltr:rounded-l-md ltr:border-r-0 rtl:rounded-r-md rtl:border-l-0'
        : 'rounded-none ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0', 'dark:border-gray-700 dark:text-white', className);
};
const Addon = forwardRef(({ as: Element = 'div', className, position, children, ...rest }, ref) => {
    const classes = useAddonClasses({ className, position });
    return (_jsx(Element, { className: classes, ref: ref, ...rest, children: children }));
});
Addon.displayName = 'Addon';
export { Addon };
//# sourceMappingURL=Addon.js.map